export default __webpack_public_path__ + "media/images/logo-6d5c430ee182da8c5ba5ee8cc7f2e1af.png";